import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../assets/style/menu.css'
import { AiOutlineHome, AiOutlineMail, AiOutlineUser, } from 'react-icons/ai'
import { BsBagDash, BsTrophy, } from 'react-icons/bs'
import { GrGithub } from 'react-icons/gr'
import { IoIosArrowDown } from 'react-icons/io'
import { PiLinkedinLogoLight, } from 'react-icons/pi'


const Navbar = () => {
    const [togglemenu, setTogglemenu] = useState(false);

    useEffect(() => {
        const btns = document.querySelectorAll('.menu-item');
        btns.forEach(item => {
            item.addEventListener('mouseover', () => {
                item.classList.add('active')
            })
            item.addEventListener('mouseout', () => {
                item.classList.remove('active')
            })


            item.addEventListener('click', () => {
                const menulist = document.querySelectorAll('.menu-item');
                menulist.forEach(menu => {
                    menu.classList.remove('current')
                })
                let iscurrent = item.classList.contains('current')
                if (iscurrent) {
                    item.classList.remove('current')
                } else {
                    item.classList.add('current')
                }
            })
        })
    })



    return (
        <>
            <div className={`side-nav ${togglemenu ? 'toggled' : ''}`}>
                <div className="shrink-arrow" onClick={() => { setTogglemenu(false) }}>
                    <IoIosArrowDown />
                </div>
                <div className="menu">
                    <div className="menu-item current" onClick={() => { setTogglemenu(false) }}>
                        <span className='item-text'>Home</span>
                        <Link to='/' className='w-100'><button className='item-btn w-100'><AiOutlineHome /></button></Link>
                    </div>
                    <div className="menu-item" onClick={() => { setTogglemenu(false) }}>
                        <span className='item-text'>About</span>
                        <Link to='/about' className='w-100'><button className='item-btn w-100'><AiOutlineUser /></button></Link>
                    </div>
                    <div className="menu-item" onClick={() => { setTogglemenu(false) }}>
                        <span className='item-text'>Services</span>
                        <Link to='/services' className='w-100'><button className='item-btn w-100'><BsBagDash /></button></Link>
                    </div>
                    <div className="menu-item" onClick={() => { setTogglemenu(false) }}>
                        <span className='item-text'>Projects</span>
                        <Link to='/projects' className='w-100'><button className='item-btn w-100'><BsTrophy /></button></Link>
                    </div>
                    <div className="menu-item" onClick={() => { setTogglemenu(false) }}>
                        <span className='item-text'>Contact</span>
                        <Link to='/contact' className='w-100'><button className='item-btn w-100'><AiOutlineMail /></button></Link>
                    </div>


                </div>

                <div className="socials">
                    <div className="menu-item">
                        <span className='item-text'>Github</span>
                        <Link href="https://github.com/ajaykumar2070" className="w-100"><button className='item-btn w-100'><GrGithub /></button></Link>
                    </div>
                    <div className="menu-item">
                        <span className='item-text'>Linkedin</span>
                        <Link href="https://www.linkedin.com/in/ajaykumar2070" className="w-100"><button className='item-btn w-100'><PiLinkedinLogoLight /></button></Link>
                    </div>
                </div>
            </div>

            <div className={`mobile-menu ${togglemenu ? 'st-hide' : ''}`}>
                <div className="menu">
                    <div className="menu-item current">
                        <Link to='/' className='w-100'><button className='item-btn w-100'><AiOutlineHome /></button></Link>
                    </div>
                    <div className="menu-item">
                        <Link to='/about' className='w-100'><button className='item-btn w-100'><AiOutlineUser /></button></Link>
                    </div>
                    <div className="menu-item">
                        <Link to='/services' className='w-100'><button className='item-btn w-100'><BsBagDash /></button></Link>
                    </div>
                    <div className="menu-item">
                        <button className='item-btn w-100' onClick={() => { setTogglemenu(true) }}>....</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar